

import { FC, useState, ReactNode, useRef, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';
import toast from 'react-hot-toast';
import '../../../assets/css/datepicker.css'
import closeBtn from '../../../assets/images/close-btn.svg';
import { currencyFormat } from '../../../resources/helper';
import { gustoApi } from '../../../resources/hooks/api/gustoApiHook'

interface Props {
    title: string,
    data: any,
    branchData: any,
    closeModal: () => void
}

const GustoJournalDetailsModal: FC<Props> = ({ title, data, branchData, closeModal }) => {

    const { gustoVerifyAndSubmitJournal } = gustoApi();

    const [isLoading, setIsLoading] = useState<boolean>(false)

    const _handleSubmitModal = () => {
        setIsLoading(true);
        gustoVerifyAndSubmitJournal({ id: data.id, branch_id: +branchData['id'] }, (message: string, resp: any) => {
            setIsLoading(false);
            toast.success(message)
            _handleCloseModal()
        }, (message: string, resp: any) => {
            setIsLoading(false);
            toast.error(message);
        })
    }

    const _handleCloseModal = () => {
        closeModal();
    }

    return (
        <Modal show={true} onHide={_handleCloseModal} backdrop="static" animation={false} size="lg">
            <div className="">
                <div className="">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">{title}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={_handleCloseModal}><img src={closeBtn} alt="" />
                        </button>
                    </div>
                    <div className="modal-body pb-0">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className='d-flex'>
                                    <span><strong>Pay Period: </strong></span>&nbsp;
                                    <span className='text-primary'><strong>
                                        {data?.pay_period_start_date ? moment(data?.pay_period_start_date).format('YYYY-MM-DD') : 'NA'} to {data?.pay_period_end_date ? moment(data?.pay_period_end_date).format('YYYY-MM-DD') : 'NA'}
                                    </strong></span>
                                </div>
                                <div className='d-flex'>
                                    <span><strong>Pay Day: </strong></span>&nbsp;
                                    <span className='text-primary'><strong>{data.processed_date ? moment(data.processed_date).format('YYYY-MM-DD') : 'NA'}</strong></span>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-4">
                            {
                                data.breakdown && Object.keys(data.breakdown).length > 0 ? (
                                    Object.keys(data.breakdown).filter((key: string) => data.breakdown[key] !== 0).map((key: string, index: number) => (
                                        <div className="col-md-6 mb-3" key={index}>
                                            <div className="breakdown-item p-3 border rounded d-flex justify-content-between align-items-center">
                                                <span className="capitalize font-weight-bold">{key.split('_').join(' ')}:</span>
                                                <span className="text-primary font-weight-bold">{currencyFormat((data.breakdown[key] || 0).toFixed(2))}</span>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="col-sm-12">
                                        <div className="alert alert-warning text-center">
                                            <span>No Breakdown Available</span>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    <div className="modal-footer">
                        {
                            data.status == 1 ? (
                                <button type="button" className="btn btn-primary" onClick={_handleSubmitModal} disabled={isLoading}>
                                    {isLoading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : <span>Verify and Import</span>}
                                </button>
                            ) : <></>
                        }
                    </div>
                </div>
            </div>
            {/* </div> */}
        </Modal>
    )
}

export default GustoJournalDetailsModal;